export const Setup = {
    //endpoint: process.env.REACT_APP_API_ENDPOINT,
    endpoint:window.location.origin+"/api",
    payment_endpoint: process.env.REACT_APP_API_PAYMENT_ENDPOINT,
    file_endpoint: process.env.REACT_APP_API_FILE_ENDPOINT,
    version: process.env.REACT_APP_API_VERSION,
    default_malls: "MxaeJ3UvbW",
    mqtt: process.env.REACT_APP_MQTT
}

//"start": "set HTTPS=true&&react-scripts start"
//"start": "node ./server/index.js"
